import type { TransportOperationName } from "@/types_api/backend/transport/operations"

import {
  isTransportOperationReady,
  transportOperations,
} from "./transportOperationRuntime"
import {
  getTransportQueryOrganizationSlug,
  getTransportQueryWorkspaceId,
} from "./transportQueryKeys"
import { useTransportClient } from "./useTransportClient"

export function useTransportOperationContext(
  operation: TransportOperationName,
) {
  const {
    getClient,
    isAuthLoaded,
    isOrganizationSynced,
    organizationSlug,
    workspaceId,
  } = useTransportClient()
  const queryOrganizationSlug = getTransportQueryOrganizationSlug(
    operation,
    organizationSlug,
  )
  const queryWorkspaceId = getTransportQueryWorkspaceId(operation, workspaceId)
  const definition = transportOperations[operation]
  const isReady = isTransportOperationReady({
    authRequired: definition.auth === "session",
    isAuthLoaded,
    isOrganizationSynced,
    organizationRequired: definition.organizationRequired,
    organizationSlug,
  })

  return {
    getClient,
    isReady,
    organizationSlug,
    queryOrganizationSlug,
    queryWorkspaceId,
  }
}
